export const getGAKey = (partnerConfig = {}) => {
  const hostname =
    typeof window !== 'undefined' && window.location
      ? window.location.hostname
      : '';

  const isNewFormat =
    partnerConfig.production ||
    partnerConfig.staging ||
    partnerConfig.preproduction;

  let config = {};

  if (isNewFormat) {
    if (hostname.startsWith('my-customer-space-preproduction')) {
      config = partnerConfig.preproduction ?? {
        ga: 'G-X2EXLNLS48',
        gtm: 'GTM-PLH6T49F',
      };
    } else if (
      hostname.startsWith('my-customer-space-staging') ||
      hostname.includes('localhost')
    ) {
      config = partnerConfig.staging ?? {
        ga: 'G-GY4YCE7PHP',
        gtm: 'GTM-KZXDLK9Z',
      };
    } else {
      config = partnerConfig.production ?? {};
    }
  } else {
    config = {
      ga: partnerConfig.ga ?? null,
      gtm: partnerConfig.gtm ?? null,
    };
  }

  return {
    ga: config.ga ?? null,
    gtm: config.gtm ?? null,
  };
};
